import { definePreset } from "@primeng/themes"
import Aura from "@primeng/themes/aura"

const PampaTema = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#eef5ff',
            100: '#d9e9ff',
            200: '#bcd8ff',
            300: '#8dbfff',
            400: '#579dff',
            500: '#2f7bf4',
            600: '#0b5fd5',
            700: '#0a4fb4',
            800: '#0d448f',
            900: '#103a73',
            950: '#0d2445'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
});

export default PampaTema;
